// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dosiin-tab-bar-pc .tab-bar-content-item .tab-bar-content-item-detail{letter-spacing:1.5px}", ""]);
// Exports
module.exports = exports;
